import React, { useState } from 'react';
import { Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import Img01 from '../../assets/images/guide/guidedraw01.png';
import Img02 from '../../assets/images/guide/guidedraw02.png';
import Img03 from '../../assets/images/guide/guidedraw03.png';
import TopNavigation from '../../components/atoms/TopNavigation';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import '../../assets/css/swipe.css';

export const DrawInfoSwipe = () => {
  return (
    <SwipeWrap>
      <Swiper pagination={true} modules={[Pagination]} className="mySwiper">
        <SwiperSlide>
          <img src={Img01} alt="Guide" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={Img02} alt="Guide" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={Img03} alt="Guide" />
        </SwiperSlide>
      </Swiper>
    </SwipeWrap>
  );
};

export default function GuideDraw() {
  const navigate = useNavigate();

  return (
    <Container component="main">
      <TopNavigation
        type="back"
        handleEvent={() => navigate('/golfunguide')}
        subTitle="게임 - 뽑기 게임"
      >
        골펀 가이드
      </TopNavigation>
      {DrawInfoSwipe()}
    </Container>
  );
}

const SwipeWrap = styled.div`
  height: 90vh;
`;
